import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import FeatureHighlight from '../components/FeatureHighlight';
import EmployeeApp from '../components/EmployeeApp';
import Studies from '../components/Studies';
import HowItWorks from '../components/HowItWorks';
import SocialProof from '../components/SocialProof.js';
import Pricing from '../components/Pricing';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

function LandingPage() {
  return (
    <div className="landing-page">
      <Navbar />
      <Hero />
      <About />
      <FeatureHighlight />
      <EmployeeApp />
      <Studies />
      <HowItWorks />
      <SocialProof />
      <Pricing />
      <CTA />
      <Footer />
    </div>
  );
}

export default LandingPage;
